import React from 'react';
import { Link } from 'react-router-dom';

export default function Wochenplaner() {
  return (
    <div style={{ maxWidth: 600, padding: '60px 0', margin: '0 auto' }}>
      <div style={{
        background: 'var(--surface)', border: '1px solid var(--border)',
        borderRadius: 'var(--r3)', padding: '48px 40px', textAlign: 'center',
      }}>
        <div style={{ fontSize: '3rem', marginBottom: 16 }}>📅</div>
        <h2 style={{
          fontFamily: 'var(--font-serif)', fontSize: '1.4rem',
          color: 'var(--txt)', marginBottom: 8,
        }}>
          Wochenplaner
        </h2>
        <p style={{ color: 'var(--txt3)', fontSize: '0.88rem', marginBottom: 16 }}>
          Diese Funktion ist in Entwicklung.<br />
          Plane deine Mahlzeiten für die ganze Woche und erstelle automatisch eine Einkaufsliste.
        </p>
        <div style={{
          display: 'inline-block',
          fontSize: '0.72rem', fontWeight: 700,
          background: 'var(--amber-pale)', color: 'var(--amber)',
          padding: '4px 12px', borderRadius: 6,
          marginBottom: 20,
        }}>
          In Arbeit
        </div>
        <p style={{ color: 'var(--txt3)', fontSize: '0.82rem', marginBottom: 12 }}>
          Möchtest du benachrichtigt werden, wenn der Wochenplaner verfügbar ist?
        </p>
        <a
          href="mailto:hallo@strixly.at?subject=Wochenplaner%20Benachrichtigung&body=Bitte%20benachrichtigt%20mich%2C%20wenn%20der%20Wochenplaner%20verf%C3%BCgbar%20ist."
          className="btn btn-primary"
          style={{ marginBottom: 16 }}
        >
          📬 Benachrichtige mich
        </a>
        <br />
        <Link to="/dashboard" className="btn btn-ghost" style={{ marginTop: 4 }}>
          ← Zurück zur Startseite
        </Link>
      </div>
    </div>
  );
}
